import { render, staticRenderFns } from "./footer-mobile.vue?vue&type=template&id=ac735e4c"
import script from "./footer-mobile.vue?vue&type=script&lang=js"
export * from "./footer-mobile.vue?vue&type=script&lang=js"
import style0 from "./footer-mobile.vue?vue&type=style&index=0&id=ac735e4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports